module.exports = __webpack_public_path__ + "assets/img/line5.dee79a9c.png";